export const numberRestriction = (value: string): string => {
  return value.replace(/[^0-9]/g, '');
};

export const signedDecimalRestriction = (value: string): string => {
  let result = '';
  let hasDot = false;

  for (const char of value) {
    if (char === '-' && result.length === 0) {
      result = '-';
    } else if (char === '.' && !hasDot) {
      hasDot = true;
      result += '.';
    } else if (/[0-9]/.test(char)) {
      result += char;
    }
  }

  return result;
};

export const normalizeSignedDecimal = (value: string): string => {
  const sanitized = signedDecimalRestriction(value.trim());
  if (sanitized === '-' || sanitized === '.' || sanitized === '-.') {
    return '';
  }
  return sanitized.endsWith('.') ? sanitized.slice(0, -1) : sanitized;
};

export const isValidSignedDecimal = (value: string): boolean => {
  return /^-?(\d+\.?\d*|\.\d+)$/.test(value);
};

export const alphanumericRestriction = (value: string): string => {
  return value.replace(/[^A-Za-z0-9]/, '');
};

export const halfCharacterRestriction = (value: string): string => {
  return value.replace(/[^A-Za-z0-9!-/:-@¥[-`{-~]/, '');
};
